import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import * as state from '@/components/AssetLabelling/state';

export const useVisibleCuboids = () => {
  const allCuboids = useAtomValue(state.cuboids);
  const cuboidClassById = useAtomValue(state.cuboidClassById);
  const hiddenCuboidIds = useAtomValue(state.hiddenCuboidIds);

  const visibleCuboids = useMemo(
    () =>
      allCuboids.filterValues(
        (value, key) =>
          !hiddenCuboidIds.has(key) && (cuboidClassById?.[value.cuboidClassId].isVisible ?? true)
      ),
    [allCuboids, cuboidClassById, hiddenCuboidIds]
  );

  return visibleCuboids;
};
